<template>
<vs-row class="modal_view_holder">
  <!-- {{file_repository_id}} -->
  <!-- {{uploadUrl}} -->
  <!-- {{deletedFile}} -->
   <div v-if="isBrowseContent">
      
      <vs-popup fullscreen title="" :active.sync="isBrowseContent" class="childImportPopUp">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
          
        ></import-browse-files-model>
      </vs-popup>
    </div>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
       <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
          <div class="collapse-item">
         <div class="flex justify-between header" slot="header" @click="isCollapseCard=!isCollapseCard" :class="{activeCollapse: isCollapseCard}">
             <!-- files : <pre>{{files}}</pre> -->
             <!-- fileRecords: <pre>{{fileRecords}}</pre> -->
             <!-- deletedFile: <pre>{{deletedFile}}</pre> -->
             <h5>Files</h5>
            <span class="material-icons">keyboard_arrow_down</span>
          </div>
          <div class="collapseContent" v-show="isCollapseCard" :class="{active: isCollapseCard}">
         
        <div class="flex justify-between">
          <vs-tooltip class="inline-block" :text="theme != 'list' ? 'List' : 'Grid'" color="primary" position="top">
            <vs-button
              class="mb-2 includeIcon includeIconOnly"
              color="primary"
              type="filled"
              @click.prevent="switchTheme"
            >
              <span v-if="theme != 'list'" class="material-icons-outlined">format_list_bulleted</span>
              <!-- <span v-if="theme != 'list'">List View</span> -->
              <span v-if="theme == 'list'" class="material-icons-outlined">grid_view</span>
              <!-- <span v-if="theme == 'list'">Grid View</span> -->
            </vs-button>
          </vs-tooltip>
           <!-- <vs-tooltip class="inline-block align-bottom" color="primary"
                text="Select files From Gdrive"
              >
                <vs-button
                  class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
                  color="primary"
                  type="border"
                  @click="driveIconClicked()"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
                </vs-button>
              </vs-tooltip> -->
             
    </div>

        <!-- {{lesson_file_index}} -->
        <!-- {{imagevalidation}} -->
        <div class="cstm_vuefileagent_holder">
          <VueFileAgent
            ref="vueFileAgent"
            :theme="theme"
            :multiple="true"
            :deletable="true"
            :meta="true"
            :accept="'image/*'"
            :maxSize="'10000MB'"
            :maxFiles="5"
            :helpText="imageHint"
            :errorText="{
              type: 'Invalid file type. Only images Allowed',
              size: 'Files should not exceed 10MB in size',
            }"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            v-model="fileRecords"
          @upload:error="uploadEvent('upload:error', $event)"

          ></VueFileAgent>
          <p class="or_text_holder">(or)</p>
          <vs-tooltip color="primary" class="inline-block align-bottom"
            text="Import File From Your Existing System"
          >
            <vs-button
              class="mb-6 mx-1 icon_large_btn"
              color="primary"
              type="filled"
              icon="folder_special"
              @click="isBrowseContent = true"
              ></vs-button
            >
          </vs-tooltip>
          <vs-tooltip class="inline-block align-bottom" color="primary"
                text="Select files From Gdrive"
              >
                <vs-button
                  class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
                  color="primary"
                  type="border"
                  @click="driveIconClicked()"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
                </vs-button>
              </vs-tooltip>
        </div>
    <div v-if="fileRecordsForUpload.length">
    <vs-divider/>
    <vs-button :disabled="!fileRecordsForUpload.length" @click="uploadFiles()">
      Upload {{ fileRecordsForUpload.length }} {{fileRecordsForUpload.length==1?'file':'files'}}
    </vs-button>
    </div>

          </div>
          </div>
      </vs-card>
      </vs-col>
  </vs-row>
</template>

<script>
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { getUploadedFilesId } from '@/api/assignment-question'

export default {
  name: 'FileUploadComponent',
  components:{
    ImportBrowseFilesModel
  },
  mixins:[GoogleAuthorization],
  props: {
    types:{
      required:true,
      type:String
    },
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    },
    files:{},
    deletedFile:{}
   
    /* AwardIndex:{
      required:false,
      type:Number,
      default:0
    } */
  },
  data () {
    return {
      isBrowseContent:false,
      isCollapseCard:true,
      theme:'grid',
      imageHint:'Choose files or drag & drop here',
      imagevalidation:'',
      auto: true,
      fileRecords: [],
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [] // maintain an upload queue
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  created () {
    const customer_id = this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
    this.imagevalidation = 'image'
    this.imageHint = 'Choose/drag & drop image'

    
  },
  watch: {
    deletedFile (newVal) {
      console.log(newVal)
      console.log(this.fileRecords, this.deletedFile)
      if (newVal) {
        
        this.fileRecords = this.fileRecords.filter((ele) => ele.upload.data.data.cdn+ele.upload.data.data.files[0].file_path !== this.deletedFile.file_image_url)
        this.deletedFile = null
      }
    }
  },
  methods: {
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    uploadEvent (eventName, data) {
      
    },
    /*   uploadFiles () {
        const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {
          

          const formData = new FormData()
          formData.append('picture[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )
      

      this.$vs.loading({
        type:'material',
        text:'Please Wait We Are Uploading Files'
      })

  
      data.then((response, error) => {
        
        
        if (response) {

          for (let i = 0;  i < response.length; i++) {

            const files_id = response[i].data.data.document_details[0].files_id
            const files_repository_id = response[i].data.data.document_details[0].files_repository_id
            const file_image_url = response[i].data.data.document_details[0].document_cdn
            

            const fileObject = {
              files_id,
              files_repository_id,
              file_image_url

            }

            this.$emit('getImage', fileObject)

          }
       

          this.$vs.loading.close()

        } else {
          
          this.$vs.loading.close()

        }
      })
        .catch(error => {
          this.$vs.loading.close()

          
        })
        .finally(this.$vs.loading.close())
    }, */
    uploadFiles () {


      // Using the default uploader. You may use another uploader instead.
      // const data = this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)
   console.log("Uploading files...",this.fileRecordsForUpload)
       
      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {
          
          console.log(fileData)
          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
           console.log(formData)
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )


      this.$vs.loading({
        type: 'material',
        text: 'Please wait we are uploading file'
      })

      data
        .then((response, error) => {
          const cdn = response[0].data.data.cdn

          if (response) {
            for (let i = 0; i < response.length; i++) {
              const file_name = response[i].data.data.files[0].file_name
              const file_path = response[i].data.data.files[0].file_path


              const raw = JSON.stringify({
                file_repository_id: this.file_repository_id,
                files: [
                  {
                    file_name,
                    file_path: `${cdn}${file_path}`
                  }
                ]
              })

              const file_id_payload = raw

              this.getUploadFiles(file_id_payload)
            }
          } else {

            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          console.warn(error)
          this.$vs.loading.close()


        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []
    },
    async getUploadFiles (file_id_payload, type = 'system') {


      try {
        const res = await getUploadedFilesId(file_id_payload)
        console.log(res)

        if (res.data.message === 'files.createFile') {
          const fileObject = {
            files_id:res.data.data.files[0].files_id,
            files_repository_id:this.file_repository_id,
            file_image_url:res.data.data.files[0].file_path

          }

          // this.$emit('getImage', fileObject)

          // this.filesInfo.push(file)

          // console.log()
          const filesDriveInfo = res.data.data.files
          console.log(filesDriveInfo)
          let filesDrive = []
        
    
          if (type === 'drive') {
            
            filesDrive = filesDriveInfo.map(ele => {
              return {
                name: ele.file_name,
                sizeText: this.bytesToSize(ele.size),
                size: ele.size,
                type: ele.file_type,
                url: ele.file_path,
                color: 'green',
                upload: {
                  data: true,
                  error: false
                }
              }
            })
            console.log(filesDriveInfo)
            this.fileRecords.push(...filesDrive)
            console.log(filesDrive)
            const repo_id = this.files_repository_id
            console.log(repo_id)
            filesDriveInfo.forEach(ele => {
              console.log(repo_id)
              console.log(ele)
              /* const filesDriveInfo = {
              

              } */
              this.$emit('getImage', {
                files_id:ele.files_id,
                files_repository_id:this.file_repository_id,
                file_image_url:ele.file_path
              })

            })
            this.$vs.notify({
              title: 'Success',
              text: 'File Uploaded Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 1000
            })
          } else {
            this.$emit('getImage', fileObject)

          }   
          this.$vs.loading.close()
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    deleteUploadedFile (fileRecord) {

      
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(
      //   this.uploadUrl,
      //   this.uploadHeaders,
      //   fileRecord
      // )
    },
    filesSelected (fileRecordsNewlySelected) {
      
       
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error) 
      
       this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )
    //    this.fileRecordsForUpload.push(fileRecordsNewlySelected)
    //  // this.fileRecordsForUpload = fileRecordsNewlySelected
    //   if (!validFileRecords.length) {
    //     this.fileRecordsForUpload.length = 0
    //   } 

      
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else if (confirm('Are you sure you want to delete?')) {
        this.fileRecordsForUpload.splice(i, 1)
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    fileDeleted (fileRecord) {
      this.$emit('removeImageEvent', fileRecord)
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        
        this.deleteUploadedFile(fileRecord)
      }
    },
    getImportFile ({ file_id, fileInfo }) {
      
      
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
      const importFileRecords = this.getImportedFile(fileInfo)

      /*  this.filesInfo.push(
        ...importFileRecords.map((ele) => {
          return {
            file: {
              'file_name': ele.name,
              'file_path': ele.url,
              'size': ele.size,
              'file_type': ele.type
            }
          }
        })
      ) */

      this.fileRecords.push(...importFileRecords)
      fileInfo.forEach(ele => {
        const fileObject = {
          files_id:ele.files_id,
          files_repository_id:this.file_repository_id,
          file_image_url:ele.file_path
        }
        this.$emit('getImage', fileObject)

      })

      /*  const fileObject = {
              files_id,
              files_repository_id,
              file_image_url

            } */


      // this.$emit('getFileId', file_id)
      
    },
    getImportedFile (fileInfo) {
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.childImportPopUp{
  z-index: 53001;

}
</style>